var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { JobCard } from './JobCard/JobCard.old';
import styles from './styles.module.styl';
var defaultJobs = [
    {
        title: 'Add Login to Your App',
        description: 'Authenticate users and secure applications.',
        imageUrl: '/docs/img/add-login.png',
        articles: [
            {
                title: 'Native/Mobile App',
                url: '/docs/microsites/add-login/add-login-native-mobile-app',
            },
            {
                title: 'Single-Page App',
                url: '/docs/microsites/add-login/add-login-single-page-app',
            },
            {
                title: 'Regular Web App',
                url: '/docs/microsites/add-login/add-login-regular-web-app',
            },
        ],
    },
    {
        title: 'Call Your API',
        description: 'Obtain the tokens your application needs.',
        imageUrl: '/docs/img/call-api.png',
        articles: [
            {
                title: 'Native/Mobile App',
                url: '/docs/microsites/call-api/call-api-native-mobile-app',
            },
            {
                title: 'Single-Page App',
                url: '/docs/microsites/call-api/call-api-single-page-app',
            },
            {
                title: 'Regular Web App',
                url: '/docs/microsites/call-api/call-api-regular-web-app',
            },
            {
                title: 'Machine-to-Machine App',
                url: '/docs/microsites/call-api/call-api-m2m-app',
            },
            {
                title: 'Input-Constrained Device',
                url: '/docs/microsites/call-api/call-api-device',
            },
        ],
    },
    {
        title: 'Protect Your API',
        description: 'Protect your API endpoints from unauthorized access.',
        imageUrl: '/docs/img/protect-api.png',
        articles: [
            {
                title: 'Protect Your API with Auth0',
                url: '/docs/microsites/protect-api/protect-api',
            },
        ],
    },
    {
        title: 'Integrate Third-Party Solutions',
        description: 'Discover and enable the integrations you need to solve identity.',
        imageUrl: '/docs/img/integrate-solutions.svg',
        articles: [
            {
                title: 'Auth0 Marketplace',
                url: 'https://marketplace.auth0.com/',
                forceFullReload: true,
            },
            {
                title: 'Become a Partner',
                url: 'https://auth0.com/partners/',
                forceFullReload: true,
            },
            {
                title: 'Integrations',
                url: '/docs/integrations',
            },
        ],
    },
];
export var JobsToBeDone = function (_a) {
    var _b = _a.jobs, jobs = _b === void 0 ? defaultJobs : _b;
    return (React.createElement("div", { className: styles.jobsToBeDone },
        React.createElement("div", { className: "container" },
            React.createElement("h1", { className: "navigator-title" }, "Learn about Auth0"),
            React.createElement("h2", { className: "header-description" }, "Explore our most common use cases with a high-level overview and next steps")),
        React.createElement("div", { className: "container ".concat(styles.jobsToBeDoneCards) }, jobs.map(function (job) { return (React.createElement(JobCard, __assign({}, job))); }))));
};
